import { render, staticRenderFns } from "./Licenses.vue?vue&type=template&id=65db70fb&scoped=true"
import script from "./Licenses.vue?vue&type=script&lang=js"
export * from "./Licenses.vue?vue&type=script&lang=js"
import style0 from "./Licenses.vue?vue&type=style&index=0&id=65db70fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65db70fb",
  null
  
)

export default component.exports